module.exports = __webpack_public_path__ + "static/media/1_zh.96a98bb0.png";